module.exports = __webpack_public_path__ + "img/change-grow-live-logo-512px.100cd88e.png";